<template>
  <CRow>
    <CCol col="12" md="6">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width:20px" /> Species
          </p>
        </CCardHeader>
       
          <CCardBody>
 <CDataTable
          :items="speciesItem"
          :fields="fields"
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Species"
          
        />

          </CCardBody>
       
       
      </CCard>
    </CCol>
    <CCol col="6" md="6">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width:20px" /> Species Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput label="Species Code" horizontal autocomplete="name" id="speciesCode" name="speciesCode" v-model="speciesCode" />
            <CInput label="Species Name" horizontal autocomplete="name" v-model="speciesName" />
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addSpecies">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteSpecies">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
       
             <CButton
                    color="secondary"
                    style="width:100px"
                    v-if="cancelButton"
                    @click="Cancelspecies"
                  >
                    <CIcon name="cilWarning" />&nbsp;Cancel
                  </CButton>

                    <CButton
                    color="info"
                   
                    v-if="addnewButton"
                    @click="addnewspecies"
                  >
                    <CIcon name="cilPencil" />&nbsp;Add New
                  </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from '../../../App.vue';
export default {
  components: { CTableWrapper },
  data() {
    return {
      fields: [
        {
          key: "speciesCode",
          sortable: true, _style:'width:10%'
        },
        {
          key: "speciesName",
          sortable: true, _style:'width:30%'
        }
        // {
        //   label: "Action",
        //   key: "ActionView"
        // }
      ],
      
      speciesCode: null,
      speciesName: "",
      speciesItem: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton:true,
      cancelButton:false,
      EditsaveButton:false,
     
    };
  },
  methods: {
    getSpeciesList() {
      APIService.speciesList().then(res => {
        if (res.status == 200) {
          this.speciesItem = res.data;
          this.speciesCode = this.speciesItem[0].speciesCode;
           this.speciesName = this.speciesItem[0].speciesName;
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editSpecies = item;
      this.speciesCode = item.speciesCode;
      this.speciesName = item.speciesName;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton =false;
      this.addnewButton=true;
      this.EditsaveButton=false;
    },
      addnewspecies(){
         this.speciesCode = null;
          this.speciesName = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =true;
          this.addnewButton=false;
           this.EditsaveButton=true
        return getSpeciesList(); 
    },
Cancelspecies(){
         this.speciesCode = null;
          this.speciesName = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =false;
          this.addnewButton=true;
           this.EditsaveButton=false,
          this.getSpeciesList();
    },
    
    addSpecies() {
      let speciesCode = this.speciesCode;
      let speciesName = this.speciesName;
      let data = {
        speciesCode,
        speciesName
      };
      APIService.saveSpecies(data).then(res => {
        if (res.status == 200) {
          this.speciesCode = null;
          this.speciesName = "";
        this.getSpeciesList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    updateSpecies() {
      let id = this.editSpecies._id;
      let speciesCode = this.speciesCode;
      let speciesName = this.speciesName;
      let value = {
        speciesCode,
        speciesName
      };
      let data = { id, value };
      APIService.speciesUpdate(data).then(res => {
        if (res.status == 200) {
          this.speciesCode = null;
          this.speciesName = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
           this.addnewButton=true;
          this.getSpeciesList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteSpecies() {
const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})



  },

delete(){

      let id = this.editSpecies._id;
      let data = { id };
      APIService.speciesDelete(data).then(res => {
        if (res.status == 200) {
          this.speciesCode = null;
          this.speciesName = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
             this.addnewButton=true;
              this.EditsaveButton=false,
          this.getSpeciesList();
        }
      });
    }
  },
  created() {
    this.getSpeciesList();
    this.getserviceList();
  }
};
</script>
<style scoped>
tbody > tr > :nth-child(1) {
  color: red;
  width: 200px;
  text-align: center;
}
.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border: inset;
}
</style>